import tableConfig from '@/views/pages/tableConfig'

export default function config(moduleName = '') {
  // Table Handlers
  const tableColumns = [
    { key: 'index', label: '#' },
    { key: 'organization', label: 'Organization', sortable: true },
    { key: 'user', label: 'Student', sortable: true },
    { key: 'dc_type', label: 'Dc Type', sortable: true },
    { key: 'direction', label: 'Direction', sortable: true },
    { key: 'edu_lang', label: 'Education Language', sortable: true },
    { key: 'quarter', label: 'Quarter', sortable: true },
    { key: 'status', label: 'Status', sortable: true },
  ]

  return {
    tableColumns,
    ...tableConfig(moduleName, { endpoint: `${moduleName}/advisorStudents` }),
  }
}
